<template>
  <div :class="{ tool: nt }" @click="$emit('click')"
  >
    <span>{{ title }}</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Tool',

  data() {
    return {
      hover: false
    }
  },

  props: {
    title: {},
    nt: {
      default: true,
    },
  },
};
</script>
<style scoped lang="scss">
.tool,
.navt {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
